// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".core-bce-passport-agreement-a55eb{bottom:24px;color:#151b26;font-size:14px;left:0;position:absolute;text-align:center;width:100%}.core-bce-passport-agreement-a55eb a{color:#2468f2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bce-passport-agreement": "core-bce-passport-agreement-a55eb",
	"bcePassportAgreement": "core-bce-passport-agreement-a55eb"
};
export default ___CSS_LOADER_EXPORT___;
